export default {
  root: {
    letterSpacing: 1,
    color: '#00000099',
    fontSize: 14,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 400,
  },
};
